<style media="print">
    /* table {
        border-collapse: collapse;
    }
    table thead tr th, .custom-td {
        border-top: 2px solid #000000;
        border-bottom: 2px solid #000000;
        padding: 8px 8px;
    }
    table tbody tr td {
        text-align: center;
    }
    table th, table td {
        padding: 4px 8px;
    }

    .layout-ceiling {
        display: none;
    }

    .ivu-col-span-20{
        width: 100%;
        z-index: 999;
        position: absolute;
    } */

     @page
      {
          size:  auto;   /* auto is the initial value */
          margin: 0mm;  /* this affects the margin in the printer settings */
      }

      html
      {
          background-color: #FFFFFF;
          margin: 0px;  /* this affects the margin on the html before sending to printer */
      }

      body
      {
          margin: 0mm 0mm 0mm 0mm; /* margin you want for the content */
      }

</style>

<template>
    <div style="margin: 12px; color: #000;">
        <!-- title -->
        <h1 style="text-align: center; border-bottom: 4px solid #000;"> NOTA </h1>
        <br><br>

        <!-- header -->
        <section>
            <!-- left -->
            <table style="width:60%; float: left;">
                <tr>
                    <td>Marking</td>
                    <td>:</td>
                    <td>{{ kontras.markingcode }}</td>
                </tr>
                <tr>
                    <td>Bapak / Ibu</td>
                    <td>:</td>
                    <td style="text-transform: uppercase">{{ kontras.markinginfoname }}</td>
                </tr>
                <tr>
                    <td>Telepon</td>
                    <td>:</td>
                    <td>{{ kontras.markinginfophone1 }}</td>
                </tr>
                <tr>
                    <td>Alamat</td>
                    <td>:</td>
                    <td>{{ kontras.markinginfoaddress1 }}</td>
                </tr>
            </table>

            <!-- right -->
            <table style="width:30%; float: right;">
                <tr>
                    <td>Tgl. Nota</td>
                    <td>:</td>
                    <td>{{ kontras.kontraCreatedAt | dateFormatted2}}</td>
                </tr>
                <tr>
                    <td>Jatuh Tempo</td>
                    <td>:</td>
                    <td>{{ kontras.dueDateDay }} Hari</td>
                </tr>
                <tr>
                    <td>Tgl. Jatuh Tempo</td>
                    <td>:</td>
                    <td>{{ kontras.lastInvoicedateDue | dateFormatted2 }}</td>
                </tr>
            </table>
        </section>

        <br><br><br><br><br><br><br>
        <!-- detail -->
        <section>
            <table width="100%">
                <thead>
                    <tr>
                        <th>NO</th>
                        <th>LOAD</th>
                        <th>PARTAI</th>
                        <th>BONGKAR</th>
                        <th>INDEX</th>
                        <th>ITEM</th>
                        <th>CTNS</th>
                        <th>VOL/GW</th>
                        <th>HARGA</th>
                        <th>TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(invoice, idx) in kontras.invoices">
                        <td>{{ ++idx }}</td>
                        <td>{{ invoice.loaddate | dateFormatted2 }}</td>
                        <td>{{ invoice.containercode }}</td>
                        <td>{{ invoice.loaddate | dateFormatted2 }}</td> <!-- belum ada unloaddatenya, sementara pake loaddate -->
                        <td>{{ invoice.detail.mainFees[0].ongkir.noIndex }}</td>
                        <td style="text-transform: uppercase;">{{ invoice.detail.mainFees[0].item }}</td>
                        <td>{{ invoice.totalctns }}</td>
                        <td>{{ invoice.totalvolume != "0.000000" ? invoice.totalvolume : invoice.totalgw | toFixed3 }}</td>
                        <td>{{ invoice.detail.mainFees[0].ongkir.markingprice | numberFormatted }}</td>
                        <td>{{ invoice.invoicefee | numberFormatted}}</td>
                    </tr>
                    <tr>
                        <td class="custom-td" colspan="2"></td>
                        <td class="custom-td" colspan="7"><strong>GRAND TOTAL</strong></td>
                        <td class="custom-td"><strong>{{ kontras.grandTotal | numberFormatted }}</strong></td>
                    </tr>
                    <br />
                     <tr>
                        <td colspan="3"><strong>Diketahui</strong></td>
                        <td colspan="4"><strong>Diterima Oleh,</strong></td>
                        <td colspan="3"><strong>Kembali Tanggal :</strong></td>
                    </tr>
                    <br><br><br><br>
                    <tr>
                        <td colspan="3"></td>
                        <td colspan="4"><strong>Nama Jelas TTD / Cap Perusahaan</strong></td>
                        <td colspan="3"></td>
                    </tr>
                </tbody>
            </table>
      </section>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                kontras : {}
            }
        },
        mounted() {
            let lsKontrasProp = localStorage.getItem('kontrasProp')

            this.kontras = JSON.parse(lsKontrasProp);

            setTimeout(() => {
                window.print();
                window.close();
            }, 2000)
        },
    }
</script>



// WEBPACK FOOTER //
// pdfKontraRePrint.vue?44b021e6